import React from 'react'
import FooterText from '../ui/atoms/FooterText'
import { Brand } from './typings'

const tjx: Brand = {
  clientInfo: {
    displayName: 'TJX',
    accountNumberLengths: [16],
    footerDisplay: 'Store Locator',
    footerLink: 'https://locator.tjxrewards.com/?intcmp=RTJXDPFTSTLCA01',
    applicationUrl:
      'https://apply.syf.com/eapply/eapply.action?clientCode=TJX&siteCode=tjaasl8d0',
    dsecApigeeClientId: {
      development: 'tjIjT3oNfOsp9KPPPnmqKGo3EXABFWGe',
      production: 'cIglc3REpYdFBYDa81JGZxR3oivO5WZI'
    },
    persistApigeeClientId: { development: '', production: '' },
    setpayApigeeClientId: {
      development: '',
      production: ''
    },
    metaTagCardTitle: {
      en: 'Credit Card',
      es: 'Tarjeta de Crédito'
    },
    metaTagCardDescription: {
      en: `Log into your TJX credit card account online to pay your bills, check your FICO score, sign up for paperless billing, and manage your account preferences`,
      es: `Ingrese a su cuenta de la Tarjeta de Crédito TJX en línea para pagar sus facturas, revisar su puntuación FICO, inscribirse en facturas digitales y manejar su cuenta.`
    },
    languages: ['en', 'es'],
    vanityUrl: 'TJMaxx.com',
    hostname: 'tjx.syf.com',
    linkingRedirect: '',
    ivaKey: '2d0a22fb-dc62-4589-a5b6-a19869b8c8f3',
    hasMss: true,
    hasCpl: true,
    promoUrl: '',
    hasCplOldErrorCode: false,
    isMultiAccount: false,
    footerContent: {
      en: (
        <>
          <FooterText>
            The TJX Rewards Mastercards are issued by Synchrony Bank pursuant to
            a license by Mastercard International Incorporated. Mastercard,
            World Mastercard and the circles design are registered trademarks of
            Mastercard International Incorporated.
          </FooterText>
          <FooterText>
            The Contactless Indicator mark, consisting of four graduating arcs,
            is a trademark owned by and used with permission of EMVCo, LLC.
          </FooterText>
          <FooterText>
            Your TJX Rewards® credit card is issued by Synchrony Bank. The
            Synchrony Bank Privacy Policy governs the use of the TJX Rewards®
            credit card. The use of this site is governed by the use of the
            Synchrony Bank Internet Privacy Policy, which is different from the
            privacy policy of TJX. The content and documents displayed may not
            all be provided in Spanish.
          </FooterText>
        </>
      ),
      es: (
        <>
          <FooterText>
            Las tarjetas TJX Rewards Mastercards son emitidas por Synchrony Bank
            en conformidad con una licencia de Mastercard International
            Incorporated. Mastercard, World Mastercard y el diseño de los
            círculos son marcas comerciales registradas de Mastercard
            International Incorporated.
          </FooterText>
          <FooterText>
            La marca Contactless Indicator, que consiste en cuatro arcos
            graduales, es una marca comercial propiedad de EMVCo, LLC, y se usa
            con su autorización.
          </FooterText>
          <FooterText>
            Synchrony Bank emite su tarjeta de crédito TJX Rewards®. La Política
            de Privacidad de Synchrony Bank rige el uso de la tarjeta de crédito
            TJX Rewards®. El uso de este sitio se rige por el uso de la Política
            de Privacidad de Internet de Synchrony Bank, que es diferente de la
            Política de Privacidad de TJX. Es posible que el contenido y los
            documentos que se muestran pueden no se proporcionen en español.
          </FooterText>
        </>
      )
    },
    phoneNumbers: {
      loan: '',
      dualcard: '1-877-890-3150',
      plcc: '1-800-952-6133',
      fraud: '1-877-890-3150',
      customerService: '1-844-416-8289'
    },
    iOSAppId: '',
    androidApp: {
      id: '',
      author: '',
      title: '',
      image: ''
    },
    crossBorder: false,
    cplHeroBannerDisplayName: '',
    termsOfService: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tjx/en/html/ess013020.html',
      es: '/essimages/cs/groups/ess_webasset/dualcard/@tjx/es/html/ess014839.html'
    },
    onlinePrivacy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tjx/en/html/ess012824.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@tjx/es/html/ess013640.html'
    },
    privacyPolicy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tjx/en/html/ess012825.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@tjx/es/html/ess013029.html'
    },
    websiteUsage: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tjx/en/html/ess012826.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@tjx/es/html/ess013639.html'
    },
    voice: {
      cardName: '',
      google: {
        termsAndConditionsLink: ''
      },
      alexa: {
        termsAndConditionsLink: ''
      }
    }
  },
  palette: {
    button: {
      primary: {
        text: '#333333',
        hover: '#e57e70 '
      },
      secondary: {
        hover: '#f2ddda'
      },
      background: '#FF8E7E'
    },
    field: {
      icon: '#000000',
      focus: '#34657F',
      label: ''
    },
    progressStepBar: {
      fill: '#000000',
      label: '#000000'
    },
    progressBar: {
      complete: '',
      error: '#c63527',
      inProgress: '#0072ad',
      background: '#e9eaeb'
    },
    checkbox: {
      background: '#b28f2f',
      font: '#FFFFFF'
    },
    switch: { background: '' },
    heroBackground: '',
    bodyBackground: '#FFFFFF',
    iconBackground: '#000000',
    headerBackground: '#ffffff',
    modalBackground: '#F9F9F9',
    formBackground: '#f9f6ee',
    headerDivider: '#b28f2f',
    footerDivider: '#f6f5f6',
    contrastingText: '#000000',
    bodyText: '#333333',
    languageSelector: '#05458E',
    focus: '',
    link: '#05458E',
    footer: {
      background: '#fcfcfc',
      text: '#333333',
      link: '#333333'
    }
  },
  images: {
    logo: {
      en: '/assets/tjx/logo.svg',
      es: '/assets/tjx/logo.svg'
    },
    hero: '/assets/tjx/background.jpg',
    heroBgDesktop: '/assets/tjx/desktop.jpg',
    heroBgMobile: '/assets/tjx/mobile.jpg',
    mainPromo: {
      en: '/assets/tjx/promo_en.png',
      es: '/assets/tjx/promo_es.png'
    },
    voiceCplLogo: ''
  }
}

export default tjx
